import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Reviews } from "@/components/site/Reviews";
import { Services } from "@/components/site/Services";
import { About } from "@/components/site/About";
import { WhyChooseUs } from "@/components/site/WhyChooseUs";
import { Gallery } from "@/components/site/Gallery";
import { FAQ } from "@/components/site/FAQ";
import { QuoteForm } from "@/components/site/QuoteForm";
import { Footer } from "@/components/site/Footer";
import { FloatingCall } from "@/components/site/FloatingCall";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        {/* Reviews hidden for now — re-enable by uncommenting <Reviews /> */}
        {/* <Reviews /> */}
        <Services />
        <About />
        <WhyChooseUs />
        <Gallery />
        <FAQ />
        <QuoteForm />
      </main>
      <Footer />
      <FloatingCall />
    </>
  );
}
